// ================
// EVENTS INTERFACE
// ================
// Ver documentación en:
// https://nodejs.org/api/events.html#events_class_eventemitter

// Escoger el que más nos guste...
import EventEmitter from 'events';
// import EventEmitter from 'event-emitter';
// import EventEmitter from 'eventemitter3';

const ee = new EventEmitter();
ee.setMaxListeners(0);
// Esto funciona de lujo.
// ee.on('hu-start-connection', () => console.log('Connection started'));
// ee.on('hu-query-send-message', (a) => console.log(`Sending message: ${a.text}`))


// ee.on('hu-query-send-message',)
// Test
// setTimeout(() => ee.emit('hu-start-connection'), 1000);
// setTimeout(() => ee.emit('hu-query-send-message', { text: 'HOLA!' }), 2000);

export default ee;


// WEBPACK FOOTER //
// ../UmiCore/src/EventDriver.js